module.exports = __webpack_public_path__ + "static/media/company-name-show.3b382471.png";